import React from "react"

const CartContext = React.createContext({
    cartList: [],
    addCartItem: () => { },
    deleteCartItem: () => { },
    incrementCartItemQuantity: () => { },
    decrementCartItemQuantity: () => { },
    removeAllCartItems: () => { },
})

export default CartContext